import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-2.5 rounded-xl bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 transition-all active:scale-95"
      aria-label="Toggle theme"
    >
      {theme === 'light' ? (
        <Moon size={20} className="animate-in zoom-in spin-in-45 duration-300" />
      ) : (
        <Sun size={20} className="animate-in zoom-in spin-in-90 duration-300" />
      )}
    </button>
  );
};

export default ThemeToggle;
